import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const CONSENT_KEY = "starways_cookie_consent_v1";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let stored = null;
    try {
      stored = localStorage.getItem(CONSENT_KEY);
    } catch {
      // private mode / localStorage blocked
      stored = null;
    }
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const save = (choice) => {
    try {
      localStorage.setItem(
        CONSENT_KEY,
        JSON.stringify({ choice, ts: new Date().toISOString() })
      );
    } catch {
      /* ignore */
    }
    if (choice === "accepted" && typeof window !== "undefined" && typeof window.loadGA === "function") {
      window.loadGA();
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      role="dialog"
      aria-live="polite"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 z-[180] max-w-sm sw-cookie"
    >
      <div className="flex items-start justify-between gap-4 mb-2">
        <strong className="sw-cookie__title">Cookies</strong>
        <button onClick={() => save("declined")} aria-label="Sluiten" data-testid="cookie-close" className="sw-round-btn" style={{ width: 30, height: 30 }}>
          <X className="w-4 h-4" />
        </button>
      </div>
      <p className="sw-cookie__text">
        We gebruiken functionele cookies om je login en ritten veilig te bewaren. Met jouw toestemming meten we
        ook anoniem bezoek met Google Analytics.{" "}
        <Link to="/cookiebeleid" className="sw-link" style={{ fontSize: 13 }}>Cookiebeleid</Link>
      </p>
      <div className="flex gap-2">
        <button onClick={() => save("accepted")} data-testid="cookie-accept" className="sw-btn" style={{ minHeight: 44, flex: 1, fontSize: 14, borderRadius: 12 }}>
          Akkoord
        </button>
        <button onClick={() => save("declined")} data-testid="cookie-decline" className="sw-btn sw-btn--ghost" style={{ minHeight: 44, flex: 1, fontSize: 14, borderRadius: 12 }}>
          Alleen functioneel
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
